
import { RevCard } from '@ds/components/Card'

export default {
  components: {
    RevCard,
  },
  props: {
    steps: {
      type: Array,
      default: () => [],
    },
  },
}
